import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ReactComponent as Add } from '../../res/add.svg';
import ButtonWithIcon from '../../components/ButtonWithIcon';
import Slider from '../../components/Slider';
import PopupTemplate03 from '../../popups/PopupTemplate03';

import styles from './styles';

class B15congress2 extends React.Component {
  renderColumn() {
    const { classes, blockData, onPopup } = this.props;
    return (
      <div className={classes.column}>
        {blockData.articles.map((item, idx) => (
          <div key={idx} className={classes.article}>
            <Typography variant="h6">{parse(item.title)}</Typography>
            <ButtonWithIcon color="blue" icon={<Add />} onClick={() => onPopup(item.popupTrigger, true)}>
              {parse(item.btn)}
            </ButtonWithIcon>
          </div>
        ))}
      </div>
    );
  }

  renderSlider() {
    const { classes, blockData } = this.props;
    return (
      <div className={classes.content}>
        <Slider sliderData={blockData.sliderData} color="teal" imgPath="blocks" imgFormat="imgCover"></Slider>
      </div>
    );
  }

  render() {
    const {
      classes,
      blockData,
      baseUrl,
      popupSeqCongressData,
      popupDigitalCongressData,
      popupReportCongressData,
      popupsState,
      onPopup,
    } = this.props;
    const baseUrlBlock = `${baseUrl}/blocks/`;

    return (
      <div style={{ backgroundImage: `url(${baseUrlBlock}${blockData.bg})` }} className={classes.blockContainer}>
        {this.renderColumn()}
        {this.renderSlider()}
        <PopupTemplate03
          popupData={popupSeqCongressData}
          open={!!popupsState.popupSeqCongress}
          baseUrl={baseUrl}
          color={popupSeqCongressData.color}
          onClose={() => onPopup('popupSeqCongress', false)}
        ></PopupTemplate03>
        <PopupTemplate03
          popupData={popupDigitalCongressData}
          open={!!popupsState.popupDigitalCongress}
          baseUrl={baseUrl}
          color={popupDigitalCongressData.color}
          onClose={() => onPopup('popupDigitalCongress', false)}
        ></PopupTemplate03>
        <PopupTemplate03
          popupData={popupReportCongressData}
          open={!!popupsState.popupReportCongress}
          baseUrl={baseUrl}
          color={popupReportCongressData.color}
          onClose={() => onPopup('popupReportCongress', false)}
        ></PopupTemplate03>
      </div>
    );
  }
}

B15congress2.propTypes = {
  classes: PropTypes.object.isRequired,
  baseUrl: PropTypes.string.isRequired,
  blockData: PropTypes.object.isRequired,
  popupsState: PropTypes.object,
  onPopup: PropTypes.func,
  popupSeqCongressData: PropTypes.object,
  popupDigitalCongressData: PropTypes.object,
  popupReportCongressData: PropTypes.object,
};

export default withStyles(styles)(B15congress2);
